import React from "react";
import {
  RefreshCw,
  Home,
  CheckCircle2,
  Cog,
  Construction,
  ShieldCheck,
  Clock3,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { motion } from "motion/react";
import logo from "../../assets/logo.png";
import "./MaintenancePage.css";

export default function MaintenancePage() {
  const navigate = useNavigate();

  return (
    <div className="maintenance-page">
      <div className="maintenance-bg-grid" />
      <div className="maintenance-bg-glow maintenance-bg-glow--one" />
      <div className="maintenance-bg-glow maintenance-bg-glow--two" />

      <motion.main
        className="maintenance-shell"
        initial={{ opacity: 0, y: 28, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1] }}
      >
        <section className="maintenance-content">
          <img src={logo} alt="LEG-UP" className="maintenance-logo" />

          <div className="maintenance-status">
            <span />
            Maintenance in progress
          </div>

          <h1>Scheduled maintenance</h1>

          <p>
            We are currently improving the LEG-UP platform. Your data remains
            safe and no action is required.
          </p>

          <div className="maintenance-info-grid">
            <div>
              <Clock3 size={18} />
              <span>Estimated availability</span>
              <strong>Shortly</strong>
            </div>

            <div>
              <ShieldCheck size={18} />
              <span>Data status</span>
              <strong>Secure</strong>
            </div>
          </div>

          <div className="maintenance-checks">
            <div>
              <CheckCircle2 size={16} />
              Your data is safe
            </div>
            <div>
              <CheckCircle2 size={16} />
              No action is required
            </div>
            <div>
              <CheckCircle2 size={16} />
              We will be back online shortly
            </div>
          </div>

          <div className="maintenance-actions">
            <button type="button" onClick={() => window.location.reload()}>
              <RefreshCw size={17} />
              Refresh
            </button>

            <button type="button" onClick={() => navigate("/")}>
              <Home size={17} />
              Return home
            </button>
          </div>
        </section>

        <aside className="maintenance-visual-panel">
          <motion.div
            className="maintenance-main-icon"
            animate={{ y: [0, -7, 0] }}
            transition={{ duration: 2.8, repeat: Infinity, ease: "easeInOut" }}
          >
            <Construction size={48} />
          </motion.div>

          <motion.div
            className="maintenance-gear maintenance-gear--one"
            animate={{ rotate: 360 }}
            transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
          >
            <Cog size={34} />
          </motion.div>

          <motion.div
            className="maintenance-gear maintenance-gear--two"
            animate={{ rotate: -360 }}
            transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
          >
            <Cog size={26} />
          </motion.div>

          <div className="maintenance-progress-card">
            <div className="maintenance-progress-card__top">
              <span>Platform update</span>
              <strong>Verifying</strong>
            </div>

            <div className="maintenance-progress">
              <motion.div
                animate={{ x: ["-100%", "120%"] }}
                transition={{
                  duration: 2.6,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />
            </div>
          </div>
        </aside>
      </motion.main>
    </div>
  );
}
